import { render } from "preact";
import { Workbox } from "workbox-window";

// Self-hosted variable fonts — bundled, never fetched from a third-party
// CDN, so no visitor IP leaks to a font host (on-brand for a privacy-first
// app; see the About note in Settings). Fontsource splits each face into
// per-language @font-face blocks keyed by unicode-range, so an
// English-primary reader only ever downloads the latin woff2; the other
// subsets sit unused in the deploy tree and are never fetched.
import "@fontsource-variable/inter";
import "@fontsource-variable/newsreader";

import { App } from "./shell/App";
// tokens.css MUST load before styles.css: it defines every custom property
// the component styles reference. Order is load-order here.
import "./styles/tokens.css";
import "./styles.css";
// Apply the persisted theme choice (light/dark/system) to <html> as early
// as possible so there's no flash of the wrong theme.
import { applyStoredTheme } from "./shell/theme";

applyStoredTheme();

const root = document.getElementById("app");
if (!root) throw new Error("missing #app root");
render(<App />, root);

// Register the Service Worker. workbox-window handles the lifecycle plumbing
// (waiting, controlling, message events) so the app stays out of the SW's
// activation timing.
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  const wb = new Workbox("/sw.js", { type: "module" });
  wb.addEventListener("waiting", () => {
    // A new SW is waiting to take control. The default `autoUpdate`
    // registerType in vite-plugin-pwa skips waiting automatically on next
    // navigation; this listener only logs.
    // eslint-disable-next-line no-console
    console.info("agg: new service worker waiting");
  });
  void wb.register();
}
